export default __webpack_public_path__ + "static/media/blog-thumb-2.cf223871.png";